export default __webpack_public_path__ + "static/media/linkSent.9f54b06e.svg";